import React, { useState, useEffect } from 'react';
import '../Navbar/Styles.css';

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);

  const handleToggle = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const handleScroll = () => setScrolled(window.scrollY > 50);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <a className="logo" href="/">
        <img src='/images/logo/rico-vanhoutteghem-logo-website.png' className='logoNavbar' alt='logo of rico vanhoutteghem' />
      </a>

      <nav>
        <ul className={`nav__links ${isOpen ? 'active' : ''}`}>
          <li><a href="/" className="nav-link" onClick={closeMenu}>HOME</a></li>
          <li className={`dropdown ${productsOpen ? 'open' : ''}`}>
            <a
              href="#products"
              className="nav-link products-link"
              onClick={(e) => { e.preventDefault(); setProductsOpen(!productsOpen); }}
            >
              PRODUCTS
              <span className={`dropdown-icon ${productsOpen ? 'rotate' : ''}`}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </a>
            <ul className="submenu">
              <li><a href="/category/rings" onClick={closeMenu}>RINGS</a></li>
              <li><a href="/category/earrings" onClick={closeMenu}>EARRINGS</a></li>
              <li><a href="/category/bracelets" onClick={closeMenu}>BRACELETS</a></li>
              <li><a href="/category/pendants" onClick={closeMenu}>PENDANTS</a></li>
              <li><a href="/category/tie-clips-and-cufflinks" onClick={closeMenu}>TIE CLIPS & CUFFLINKS</a></li>
              <li><a href="/category/brooches-and-hairpins" onClick={closeMenu}>BROOCHES & HAIRPINS</a></li>
            </ul>
          </li>
          <li><a href="/mystory" className="nav-link" onClick={closeMenu}>MY STORY</a></li>
          <li><a href="/customjewelry" className="nav-link" onClick={closeMenu}>CUSTOM JEWELRY</a></li>
          <li><a className="buttonNewContact" href="/contact" onClick={closeMenu}>CONTACT</a></li>
        </ul>
      </nav>

      <button className={`toggle-button ${isOpen ? 'open' : ''}`} onClick={handleToggle}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>
    </header>
  );
};

export default NavBar;